import http from '@/services/api';

const RESOURCE_NAME = 'api/campaign';

export default {
  getCampaigns() {
    return http.get(`${RESOURCE_NAME}/all`);
  },

  getCampaignAssignments(campaignId, businessProcessId) {
    return http.get(`${RESOURCE_NAME}/${campaignId}/bp/${businessProcessId}/assignments`);
  },

  activateAgents(campaignId, businessProcessId, agentIds, duration) {
    return http.post(`${RESOURCE_NAME}/${campaignId}/bp/${businessProcessId}/assignments/activate`, {
      agentIds,
      duration
    });
  },

  deactivateAgents(campaignId, businessProcessId, agentIds, duration) {
    return http.post(`${RESOURCE_NAME}/${campaignId}/bp/${businessProcessId}/assignments/deactivate`, {
      agentIds,
      duration
    });
  },

  setTemporaryAssignmentsExpiration(campaignId, businessProcessId, expirationMinutes) {
    return http.post(`${RESOURCE_NAME}/${campaignId}/bp/${businessProcessId}/assignments/expiration`, {
      expirationMinutes
    });
  }
};
